import type { BlogCategory } from '../../types/blog';

export const BLOG_CATEGORIES: BlogCategory[] = [
  {
    id: '1',
    name: 'Market Analysis',
    slug: 'market-analysis',
    description: 'Daily and weekly analysis of Nigerian forex market trends',
    color: '#059669',
    postCount: 0
  },
  {
    id: '2',
    name: 'Exchange Rates',
    slug: 'exchange-rates',
    description: 'Live updates and insights on Naira exchange rates',
    color: '#DC2626',
    postCount: 0
  },
  {
    id: '3',
    name: 'Trading Education',
    slug: 'trading-education',
    description: 'Learn forex trading strategies and best practices',
    color: '#2563EB',
    postCount: 0
  },
  {
    id: '4',
    name: 'Economic News',
    slug: 'economic-news',
    description: 'Latest Nigerian economic developments and policy updates',
    color: '#7C3AED',
    postCount: 0
  },
  {
    id: '5',
    name: 'Official Updates',
    slug: 'official-updates',
    description: 'Central Bank of Nigeria policy changes and announcements',
    color: '#059669',
    postCount: 0
  },
  {
    id: '6',
    name: 'Safety Tips',
    slug: 'safety-tips',
    description: 'Forex trading safety and scam prevention guides',
    color: '#DC2626',
    postCount: 0
  }
];